export const ErrorType = {
    SUCCESS : 'success',
    ERROR : 'error',
    WARNING : 'warn'
}

export const ErrorMessage = {
    TASKMOVEMENTSUCCESS : `Task movement is successful. Sequence optimization in progress, task sequence will reflect shortly.`, 
    TASKMOVEMENTERROR: 'Task movement failed.',
    ITEMMOVEMENTSUCCESS: "Item movement has been successful.",
    ITEMMOVEMENTERROR: "Item movement failed.",
    TASKMOVEMENTRESTRICSTIONS: 'Task selection is restricted or inapplicable for movement. It could be due to one or more of the following reasons: \n 1. If the task state is other than planned & source or target route is other than Sorting or Loading state. \n 2. If the task address is missing. \n3. If the task state is completed. \n 4. If the task type is a break. \n 5. If the task belongs to different business location. \n 6. If the previous date has been selected.',
    MAPCOLORALERT: 'Can\'t select more than 20 routes.',
    NOTASKONROUTE: 'There is no task/stop present on the selected route',
    NOROUTE: 'No route is present on this Business Location',
    REQUIREDFIELDS: 'Please fill in all required fields correctly.',
    CREATEROUTESUCCESS: 'Route creation is successful',
    NETWORKERROR: 'Network Error! Please try again.',
    PASTTIME: 'Route cannot be created with past time',
    ROUTEEXIST: 'Route already exists',
    BARCODENOTFOUND: 'Barcode Id not found',
    PBMNOTFOUND: 'PBM order id not found',
    ADDRESSNOTFOUND: 'Address could not be found',
    ADDRESSUPDATEDSUCCESS: 'Address has been updated successfully',
    ADDRESSUPDATEDFAIL: 'Address can not be updated',
    CONTAINERNOTFOUND:'Container id not found',
    OFFLINESTATUS: `There's no internet connection, please check the connection.`,
    REJECT:'Rejected pullback to unplanned pickup',
    INVALIDTIMEERROR:'End time must be greater than begin time',
    REPORTSAVESUCCESS: 'Report created successfully',
    REPORTUPDATESUCCESS: 'Report updated successfully',
    REPORTDELETESUCCESS: 'Report deleted successfully',
    REPORTSAVEERROR: 'Failed to save report',
    REPORTDELETEERROR: 'Failed to delete report',
    CATEGORYLOADERROR: 'Failed to load categories',
    TASKSELECTIONWARNING:`Please note: task selection doesn't work with Stop View, please change the view to task view`,
    NOIMAGEFOUND: 'No image found.',
    RESTRICTIONMESSAGE: 'You do not have sufficient privileges to perform this operation. Please contact the Administrator',
    STATEUPDATEMESSAGE: 'Task State updated successfully.',
    STATEUPDATEERRORMESSAGE: 'Failed to update Task State, Please try again.',
    ROUTESTATEUPDATEMESSAGE: 'Route State updated successfully.',
    ROUTESTATEUPDATEERRORMESSAGE: 'Failed to update Route State, Please try again.',
    NODATA: 'No task records are available for export.',
    PARCELBOXREPORTSUCCESS: 'Parcelbox has been reported successfully',
    PARCELBOXREPORTFAILED: 'Parcelbox reporting failed',
    RECIPIENTSLOADERROR: 'Failed to load recipients.',
    IDENTITYLOADERROR: 'Failed to load recipient identities.',
    GETUSERCOLUMNPREFERENCE:'Failed to load User Preference, Please try again.',
    ERRORSAVEUSERCOLUMNPREFERENCE:'Failed to create column preferece, Please try again.',
    SUCCESSCREATEDUSERCOLUMNPREFERENCE:'Column Preferences created successfully.',
    SUCCESSUPDATEUSERCOLUMNPREFERENCE:'Column Preferences created successfully.',
    DELETEDCOLUMNPREFERENCE:'Column Preferences deleted successfully.',
    COLUMNVISIBILITYERROR: 'Visible Column List can\'t be empty.',
    BASEERRORMESSAGE: 'Something went wrong, please try again later.',
    COMMITOPTIMISATIONERROR: 'Failed to set optimised sequence, Please try again.',
    COMMITOPTIMISATIONSUCCESS: 'Optimised sequence set successfully.',
    SLOTINSUCCESS: 'Slot in sequence set successfully.',
    MERGE_SUCCESS: 'Tasks has been merged successfully.',
    SLOTINERROR: 'Failed to set slot in sequence, Please try again.',
    VEHICLETYPEERROR: 'Unable to load operational vehicle types. Please try again.',
    NO_DELIVER_TASKS: 'No deliver tasks found in the route. Merge cannot be performed.'
}

export const WarningMessage = {
    NOROUTEDATA: `There's no data present for the selected route OR there's no route selected. Please select the route`,
    NOADDRESSPOINTCOORDS: 'Address point coordinates not available',
    NOTASKSTOPCOORDS: 'Stop/Task coordinates not available',
    NOENTRYPOINTCOORDS: 'Entry point coordinates not available'
}
